import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { POINT_CONVERSION_COMPRESSED } from 'constants';
import successForm from './common-form';

ReactModal.setAppElement('body');

export default successForm({

    renderFields(){
        const { fields, docTypes, account_types, banks } = this.props;
        
        const docType = docTypes.find(i => i.key === fields.document_type).value;
        const account_type = account_types.find(i => i.key === fields.account_type).value;
        const bank = banks.find(i => i.code === fields.bank_code).name;
        
        return ([
            <tr key="1">
                <td>Tipo de documento</td>
                <td>{docType}</td>
            </tr>,
            <tr key="2">
                <td>Número de documento</td>
                <td>{fields.document_number}</td>
            </tr>,
            <tr key="3">
                <td>Banco</td>
                <td>{bank}</td>
            </tr>,
            <tr key="4">
                <td>Tipo de cuenta</td>
                <td>{account_type}</td>
            </tr>,
            <tr key="5">
                <td>Número de cuenta</td>
                <td>{fields.account_number}</td>
            </tr>,
            <tr key="6">
                <td>Monto (pesos colombianos)</td>
                <td>${fields.amount}</td>
            </tr>
        ])
    }

});
